module.exports = __webpack_public_path__ + "static/media/iloop.87473b2f.png";